import { render } from "./json-builder-wrapper.vue?vue&type=template&id=4044b016&scoped=true"
import script from "./json-builder-wrapper.vue?vue&type=script&lang=js"
export * from "./json-builder-wrapper.vue?vue&type=script&lang=js"

import "./json-builder-wrapper.vue?vue&type=style&index=0&id=4044b016&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4044b016"]])

export default __exports__